import mapLpuCardProps from 'src/components/pages/[town-translit]/diagnostika/analiz/_functions/mapLpuCardProps'
import mapLpuSetCard from 'src/components/pages/[town-translit]/diagnostika/analiz/_functions/mapLpuSetCard'
import {
  LPU_CARD_TYPE,
  type LpuCardsPageItem,
  type PartnerCardContextItem,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'
import type { AnalysesMappedCard } from 'src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/types'

type MapLpuCardPropsOptions = Parameters<typeof mapLpuCardProps>[1]
type MapLpuSetCardOptions = Parameters<typeof mapLpuSetCard>[1]

export type MapAnalysesCardItemOptions = {
  isFiltersEnabled: boolean
  lpuCardOptions: MapLpuCardPropsOptions
  lpuSetCardOptions: MapLpuSetCardOptions
  isSpecialPlacement?: boolean
}

export default function mapAnalysesCardItem(
  item: LpuCardsPageItem,
  {
    isFiltersEnabled,
    lpuCardOptions,
    lpuSetCardOptions,
    isSpecialPlacement = false,
  }: MapAnalysesCardItemOptions,
): AnalysesMappedCard {
  if (isFiltersEnabled && item.card_type === LPU_CARD_TYPE.PARTNER) {
    return {
      cardType: LPU_CARD_TYPE.PARTNER,
      id: item.id,
      props: mapLpuSetCard(item, lpuSetCardOptions),
    }
  }

  return {
    cardType: LPU_CARD_TYPE.LPU,
    id: item.id,
    props: {
      ...mapLpuCardProps(item, lpuCardOptions),
      ...(isSpecialPlacement ? { isSpecialPlacement: true } : {}),
    },
  }
}

export function mapAnalysesPartnerCardItem(
  item: PartnerCardContextItem,
  lpuSetCardOptions: MapLpuSetCardOptions,
): AnalysesMappedCard {
  return {
    cardType: LPU_CARD_TYPE.PARTNER,
    id: item.partner_lpuset_data.translit,
    props: mapLpuSetCard(item, lpuSetCardOptions),
  }
}
